import { render, staticRenderFns } from "./EditorHeaderMobile.vue?vue&type=template&id=4814ac7d&scoped=true&"
import script from "./EditorHeaderMobile.vue?vue&type=script&lang=ts&"
export * from "./EditorHeaderMobile.vue?vue&type=script&lang=ts&"
import style0 from "./EditorHeaderMobile.vue?vue&type=style&index=0&id=4814ac7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814ac7d",
  null
  
)

export default component.exports